import { getStepRoute } from '../data/NewRoleConstants';

export const arePreviousStepsValid = (validSteps: number[], stepNumber: number): boolean => {
  let valid = true;

  if (stepNumber !== 1) {
    for (let i = 1; i < stepNumber; i++) {
      if (!validSteps.includes(i)) {
        valid = false;
      }
    }
  }

  return valid;
};

export const getLastValidStepRoute = (validSteps: number[]): string => {
  const step = Math.max(...[1, ...validSteps]);
  return getStepRoute(step);
};
